<template>
    <div :style="backUrl ? { backgroundImage: `url(${backUrl})` , backgroundSize: 'cover', backgroundRepeat: 'no-repeat' } : {}" class="heng-tu-display">
        <!-- 顶部标题展示，与其他组件标题样式统一 -->
        <div class="top-margin"></div>
        <div v-if="title" class="component-title">{{ title }}</div>

        <!-- 横图展示区域 -->
        <div style="margin-top: 70px" class="heng-tu-list">
            <div class="heng-tu-items">
                <!-- 循环渲染每个横图项 -->
                <div
                    v-for="(item, index) in displayItems"
                    :key="index"
                    class="heng-tu-item"
                >
                    <!-- 富文本内容展示 -->
                    <div class="heng-tu-content" v-html="item"></div>
                </div>
            </div>
        </div>
        <div class="top-margin"></div>
    </div>
</template>

<script>
export default {
    name: 'HengTuDisplay',
    props: {
        // 横图数据，格式为: {"itemCount":3,"width":200,"height":400}@FUWENBEN@<p>21312大苏打</p>@FUWENBEN@<p>撒大大撒的</p>@FUWENBEN@<p>阿斯顿撒擦下次支持</p>
        sourceData: {
            type: String,
            required: true,
            default:
                '',
        },
        // 组件顶部标题
        title: {
            type: String,
            default: '',
        },
        backUrl:{
            type: String,
            default: ''
        },
        detailUrl:{
            type: String,
            default: ''
        },
    },
    data() {
        return {
            // 配置信息
            config: {
                itemCount: 3,
                width: 200,
                height: 400,
            },
            // 展示的内容项
            displayItems: [],
        };
    },
    watch: {
        sourceData: {
            immediate: true,
            handler(newSource) {
                this.parseData(newSource);
            },
        },
    },
    methods: {
        /**
         * 解析横图数据
         * @param {string} data - 格式为: JSON配置@FUWENBEN@内容1@FUWENBEN@内容2...
         */
        parseData(data) {
            if (!data) return;

            try {
                // 分割数据
                const parts = data.split('@FUWENBEN@');

                if (parts.length > 0) {
                    // 解析配置信息
                    const config = JSON.parse(parts[0]);
                    this.config = { ...this.config, ...config };

                    // 提取内容项
                    this.displayItems = parts.slice(1);

                    // 确保内容项数量与配置一致
                    if (this.displayItems.length > this.config.itemCount) {
                        this.displayItems = this.displayItems.slice(
                            0,
                            this.config.itemCount
                        );
                    }

                    // 不足则补空内容
                    while (this.displayItems.length < this.config.itemCount) {
                        this.displayItems.push('<p>无内容</p>');
                    }
                }
            } catch (e) {
                console.error('解析横图数据失败:', e);
                // 解析错误时显示默认内容
                this.displayItems = [
                    '<p>数据解析错误</p>',
                    '<p>数据解析错误</p>',
                    '<p>数据解析错误</p>',
                ].slice(0, this.config.itemCount);
            }
        },
    },
};
</script>

<style scoped>
.heng-tu-display {
    width: 100%;
    background-color: #fff;
}

/* 顶部标题样式，与页签等组件标题样式统一 */
.component-title {
    padding: 16px 20px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
}

/* 横图列表容器 */
.heng-tu-list {
    display: flex;
    justify-content: center;
    padding: 0 25px;
}

/* 横图项容器，实现水平排列且居中 */
.heng-tu-items {
    display: flex;
    gap: 30px;
    max-width: 1200px; /* 可根据实际需求调整最大宽度 */
    width: 100%;

}

/* 单个横图项样式，与效果图中卡片样式一致 */
.heng-tu-item {
    min-height: 200px;
    flex: 1;
    background-image: url(./banner-bg.png);
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    min-width: 200px; /* 可根据配置调整最小宽度 */
}

/* 横图项内容样式 */
.heng-tu-content {
    line-height: 1.6;
    color: #333;
}

.heng-tu-content p {
    margin: 0 0 16px 0;
}

.heng-tu-content p:last-child {
    margin-bottom: 0;
}

.heng-tu-content h3 {
    color: #ed0200;
    margin-top: 0;
    margin-bottom: 10px;
}

/* 响应式适配，小屏幕下自动换行 */
@media (max-width: 768px) {
    .heng-tu-items {
        flex-wrap: wrap;
    }

    .heng-tu-item {
        flex-basis: calc(50% - 10px); /* 一行显示两个 */
        margin-bottom: 20px;
    }
    .top-margin {
        height: 5vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    }
}

@media (max-width: 480px) {
    .heng-tu-item {
        flex-basis: 100%; /* 一行显示一个 */
    }

}
.top-margin {
    height: 5vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    clear: both;
}
</style>